import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { Language } from "../../models/language.model";

export namespace LanguageTypeActions {
    @logDispatcher
    export class GetLanguages {
      static readonly type = '[Language] GetLanguages';
      constructor() {}
    }
  
    @logDispatcher
    export class GetLanguagesSuccess {
      static readonly type = '[Language] GetLanguagesSuccess';
      constructor(public languages: Language[]) {}
    }
  
    @logDispatcher
    export class GetLanguagesFail {
      static readonly type = '[Language] GetLanguagesFail';
      constructor(public error: any) {}
    }
}